export default {"src":"/sg/_next/static/media/ANKLELENGTH.955c1d80.svg","height":150,"width":63,"blurWidth":0,"blurHeight":0};